import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
export const fetchEventDefinitionDetails = async (eventDefinitionId) => fetch("GET", qualifyUrl(`/events/definitions/${eventDefinitionId}`));
const useEventDefinition = (eventDefId, enabled = true) => {
  const { data, isFetching, isInitialLoading, isError } = useQuery({
    queryKey: ["get-event-definition-details", eventDefId],
    queryFn: () => fetchEventDefinitionDetails(eventDefId),
    retry: 0,
    placeholderData: keepPreviousData,
    enabled: !!eventDefId && enabled
  });
  return { data, isFetching, isInitialLoading, isError };
};
export default useEventDefinition;
